<template lang="pug" src="./technical-support.pug"></template>
<style lang="scss" src="./technical-support.scss" scoped></style>

<script>
import navigation from '@/components/navigation';
import CardEditor from './card-editor';
import OrderDetails from './order-details';
import ClientDetails from './client-details';

import { mapState, mapGetters } from 'vuex';
import config from '../../../../config.json';
import { normalizedPhone } from '@/utils/helpers';

export default {
    components: {
        'v-navigation': navigation,
        'v-card-editor': CardEditor,
        'v-order-details': OrderDetails,
        'v-client-details': ClientDetails
    },
    data: () => ({
        activeCard: {
            type: null,
            phoneNumber: null,
            orderId: null,
            reason: null,
            customReason: null,
            status: null,
            comment: null
        },
        filters: {
            type: null,
            reason: null,
            status: null
        }
    }),
    computed: {
        ...mapGetters(['roleName']),
        ...mapState({
            drawer: state => state.data.drawer,
            cards: state => state.technicalSupport.cards,
            pagination: state => state.technicalSupport.pagination,
            reasons(state) {
                const reasons = [...state.technicalSupport.reasons, 'custom'];

                const translationPath = '$vuetify.pages.ReceiveOrders.cancelOrderDetails';
                const translate = (string) => this.$vuetify.lang.t(`${string}`);

                return reasons.map(it => ({
                    text: translate(`${translationPath}.explanationsList.${it}`),
                    value: it
                }));
            },
            activeInfoNav: state => state.technicalSupport.activeInfoNav,
            cardData: state => state.technicalSupport.cardData
        }),
        callTypes() {
            return config.technicalSupport.callTypes.map(type => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.callTypes.${type}`),
                value: type
            }));
        },
        statuses() {
            return config.technicalSupport.statuses.map(status => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.statuses.${status}`),
                value: status
            }));
        },
        canEdit() {
            return ['admin'].includes(this.roleName);
        },
        headers() {
            const titles = [
                'id', 'type', 'phoneNumber', 'orderId',
                'status', 'reason', 'comment', 'dispatcher'
            ];

            if (this.canEdit) {
                titles.push('actions');
            }

            return titles.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.clientAppeals.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },

        infoNavigation() {
            return ['client-details', 'order-details'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.additionalInfo.${it}`),
                value: it
            }));
        }
    },
    created() {
        this.$store.dispatch('technicalSupport/getReasons');

        if (this.cardData) {
            this.activeCard = Object.assign({}, {
                ...this.cardData
            });
        }

        this.loadItems();
    },
    methods: {
        loadItems(page = 1) {
            this.$store.dispatch('technicalSupport/getCards', {
                page,
                ...this.filters
            });
        },

        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },

        setItemTitle(item) {
            return item.reason == 'custom' ? item.customReason : null;
        },

        isItemDisabled(item) {
            return ['resolved', 'rejected'].includes(item.status);
        },

        toggleDrawer: function() {
            this.$store.commit('data/SET_DRAWER', !this.drawer);
        },

        setActiveCard(card) {
            const keys = ['id', ...Object.keys(this.activeCard)];

            this.activeCard = Object.assign({}, {
                ...Object.select(card, keys),
                phoneNumber: normalizedPhone(card.client.user.phoneNumber)
            });

            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        resetActiveCard() {
            Object.keys(this.activeCard).forEach(key => {
                this.activeCard[key] = null;
            });

            this.$store.commit('technicalSupport/SET_CARD_DATA', null);
        },

        setActiveNav(item) {
            this.$store.commit('technicalSupport/SET_ACTIVE_INFO_NAV', item);
        }
    }
};
</script>
